export var QUERY_KEY = {
    GET_SUBSCRIPTION: 'getSubscription',
    GET_SHOPS: 'getShops',
    GET_SHOP: 'getShop',
    UPDATE_SHOP: 'updateShop',
    GET_WEBHOOKS: 'getWebhooks',
    CREATE_WEBHOOK: 'createWebhook',
    GET_FUNNELS: 'getFunnels',
    GET_EXTRASETTINGS: 'getExtraSettings',
    GET_PORTAL_USERS: 'getPortalUsers',
};
